import { render, staticRenderFns } from "./FormUploadImage.vue?vue&type=template&id=cf0faa80&scoped=true"
import script from "./FormUploadImage.vue?vue&type=script&lang=js"
export * from "./FormUploadImage.vue?vue&type=script&lang=js"
import style0 from "./FormUploadImage.vue?vue&type=style&index=0&id=cf0faa80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0faa80",
  null
  
)

export default component.exports